import useSchedulingAnalytics from 'containers/scheduling/hooks/useSchedulingAnalytics';
import { useQueryParams } from 'hooks';
import { DateTime } from 'luxon';
import { View } from 'react-big-calendar';
import { QueryParam } from 'utils/constants/queryParam';
import { useSchedulingPersistence } from '../context/SchedulingPersistenceContext';

function useCalendarViewNavigation() {
  const params = useQueryParams();
  const analytics = useSchedulingAnalytics();
  const { setCalendarView } = useSchedulingPersistence();

  function navigate(view: View, time?: DateTime) {
    if (view !== 'month' && view !== 'week' && view !== 'day') {
      throw Error(`Unsupported view ${view}`);
    }

    analytics.recordViewViewed(view);
    if (time) {
      params.setParam(QueryParam.TIME, time.toFormat('M-d-yyyy'));
    }

    setCalendarView(view);
  }

  return navigate;
}

export default useCalendarViewNavigation;
